import { PublicClientApplication, type IPublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

/**
 * Lazy singleton holder for the MSAL instance.
 *
 * <p>Deferring {@code new PublicClientApplication(...)} past module-import
 * time matters in test environments where {@code window.localStorage}
 * isn't fully implemented at jsdom boot: the constructor touches
 * localStorage, so eagerly instantiating at import time made every test
 * file that transitively imports the auth module fail to load.</p>
 *
 * <p>Production semantics are unchanged — the instance is still a
 * singleton, created exactly once on first access.</p>
 */
let instance: IPublicClientApplication | null = null;

/**
 * Return the singleton MSAL instance, creating it on first call.
 */
export function getMsalInstance(): IPublicClientApplication {
  if (instance === null) {
    instance = new PublicClientApplication(msalConfig);
  }
  return instance;
}
